<ion-content class="ion-padding">
  <usucampeao-documentos-upload [nome]="documentoNome" [tipo]="tipo" [documentoId]="documentoId" [arquivos]="arquivos" (aoRealizarUpload)="adicionarOuAtualizarDocumento($event)"></usucampeao-documentos-upload>
</ion-content>
